import { GET_CAMPAIGN_LIST_AND_SUMMARY, MODIFY_CAMPAIGN_STATUS, RESET_CAMPAIGN_STATUS }
from '../constants/action-types';

const defaultState = {
   summary: {},
   campaignsList: [],
   accountDetails: {},
   campaignStatus: null
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case GET_CAMPAIGN_LIST_AND_SUMMARY:
            return {
                ...state,
                summary: action.payload.summary,
                campaignsList: action.payload.campaigns ? action.payload.campaigns : [],
                accountDetails: action.payload.account
            }
        case MODIFY_CAMPAIGN_STATUS:
            return {
                ...state,
                campaignStatus: action.payload
            }
        case RESET_CAMPAIGN_STATUS:
            return {
                ...state,
                campaignStatus: null
            }
        default:
            return state;
    }
};
